import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import {
  useFetchEcommerceSizesMutation,
  useAddEcommerceSizeMutation,
} from "../../../features/tenant/ecommerceProduct/ecommerceSizesApi";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import toast from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { HiOutlinePlus } from "react-icons/hi";

const EcommerceSizeMaster = () => {
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme.color_shades;
  const vendorData = JSON.parse(sessionStorage.getItem("vendorData"));
  const tenant_id = vendorData.tenant_id;
  const token = sessionStorage.getItem("access_token");
  const navigate = useNavigate();

  const [sizes, setSizes] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);

  // Form states
  const [sizeName, setSizeName] = useState("");

  // API hooks
  const [fetchSizes, { isLoading: sizesLoading }] = useFetchEcommerceSizesMutation();
  const [addSize, { isLoading: addLoading }] = useAddEcommerceSizeMutation();

  const loadSizes = () => {
    fetchSizes({ slug: tenant_id, token })
      .unwrap()
      .then((res) => {
        if (res?.body) {
          setSizes(res.body);
        }
      })
      .catch((err) => {
        toast.error("Failed to load sizes");
      });
  };

  useEffect(() => {
    loadSizes();
  }, []);

  const handleAddSize = (e) => {
    e.preventDefault();
    if (!sizeName.trim()) {
      toast.error("Please enter a size name");
      return;
    }

    if (sizeName.includes(",")) {
      toast.error("Please enter a valid size name, (,) comma is not allowed");
      return;
    }
    const payload = {
      slug: tenant_id,
      token,
      name: sizeName.trim().toUpperCase(),
      type: "individual",
      individual_size_ids: [],
    };

    addSize(payload)
      .unwrap()
      .then(() => {
        toast.success("Size added successfully");
        setShowAddModal(false);
        setSizeName("");
        loadSizes();
      })
      .catch((err) => {
        toast.error(err.data?.message || "Failed to add size");
      });
  };

  return (
    <div className="flex w-full bg-gray-200 h-full justify-center min-h-screen">
      <div className="w-full">
        <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold flex justify-between items-center pr-6">
          <div>
            Size Master
            <LinksComponent />
          </div>
          <button
            onClick={() => {
              setSizeName("");
              setShowAddModal(true);
            }}
            className="flex items-center gap-2 text-white px-4 py-2 rounded text-sm hover:opacity-90 shadow-md font-medium"
            style={{ backgroundColor: primaryColor["700"] }}
          >
            <HiOutlinePlus /> Add Size
          </button>
        </div>

        <div className="p-4">
          <div className="p-4 w-full bg-white shadow rounded-lg min-h-[400px]">
            {sizesLoading && <CircleLoaderComponent />}

            {!sizesLoading && sizes.length === 0 ? (
              <div className="flex flex-col items-center justify-center p-8 text-gray-500">
                <p className="text-lg">No sizes created yet</p>
                <p className="text-sm">Click "Add Size" to create sizes.</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {sizes.map((item) => (
                      <tr key={item.id}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-800">
                          {item.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold ${
                              item.status === "1"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            }`}
                          >
                            {item.status === "1" ? "Active" : "Inactive"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add Modal */}
      {showAddModal && (
        <ModalComponent size="md" show={showAddModal} setShow={setShowAddModal}>
          <form onSubmit={handleAddSize} className="p-4 w-full">
            <h3 className="text-lg font-bold mb-4 text-gray-800">Add Size Variant</h3>
            <div className="flex flex-col gap-4">
              <InputComponent
                name="Size Name"
                type="text"
                value={sizeName}
                placeholder="e.g. S, M, L, XL, XXL"
                setValue={setSizeName}
                required
              />

              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded text-sm"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={addLoading}
                  className="px-4 py-2 text-white rounded text-sm hover:opacity-90 disabled:opacity-50"
                  style={{ backgroundColor: primaryColor["700"] }}
                >
                  {addLoading ? "Adding..." : "Add Size"}
                </button>
              </div>
            </div>
          </form>
        </ModalComponent>
      )}


    </div>
  );
};

export default EcommerceSizeMaster;
